import {useGetData} from '../apiservice/apiCall'


export function useFaq(){
	return useGetData('/api/WebApi/GetFaq')
}
